// extracted by mini-css-extract-plugin
export default {"header":"G8f6e0c","successHeader":"Gcae903 G8f6e0c","failureHeader":"G9576e5 G8f6e0c","content":"G6d29b7"};